import { Middleware } from "redux";
import { State } from "../../store";
import { dispatchAlerts } from "../../api/responseConverters";

const alertsMiddleware: Middleware<any, State> = (store) => (next) => (action) => {
  if (action.type.includes("fulfilled")) {
    const alerts = dispatchAlerts(action.payload);
    alerts && store.dispatch(alerts);
    if (action.payload?.isError) {
      return next({
        ...action,
        type: action.type.replace("fulfilled", "rejected"),
      });
    }
    if (action.payload && Object.prototype.hasOwnProperty.call(action.payload, "result")) {
      return next({ ...action, payload: action.payload.result });
    }
    return next(action);
  }

  return next(action);
};

export default alertsMiddleware;
